var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "TRTStatsModal",
        title: "Statistic Report",
        "content-class": "modal-content-full",
        "dialog-class": "modal-dialog-full",
        "modal-header-class": "ptv-modal-header",
        size: "sm",
        centered: "",
      },
      on: {
        hidden: function ($event) {
          return _vm.reset()
        },
        show: function ($event) {
          return _vm.generateStatistics()
        },
      },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function () {
            return [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex align-items-center justify-content-between w-100",
                },
                [
                  _c(
                    "div",
                    { staticClass: "modal-title-wrap" },
                    [
                      _c("fa", {
                        staticClass: "modal-title-icon",
                        attrs: { icon: ["fas", "chart-bar"] },
                      }),
                      _vm._v(" "),
                      _c(
                        "h5",
                        { staticClass: "mb-0 font-weight-semibold text-white" },
                        [_vm._v("Statistic Report")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.dataLoading
                    ? _c(
                        "span",
                        {
                          staticClass: "download-button-container",
                          attrs: { title: "Download report" },
                          on: { click: _vm.downloadReports },
                        },
                        [
                          _c("fa", {
                            attrs: { icon: ["fas", "download"], size: "lg" },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
            ]
          },
          proxy: true,
        },
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c(
                "b-row",
                { staticClass: "w-100 justify-content-end" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "close-btn px-4 py-2",
                      on: {
                        click: function ($event) {
                          return _vm.closeStatsModal()
                        },
                      },
                    },
                    [_vm._v("Close")]
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c("div", { staticClass: "trt-form-area" }, [
        _c("div", { staticClass: "trt-form-row" }, [
          _c(
            "div",
            { staticClass: "trt-field trt-field--type" },
            [
              _c("label", { staticClass: "trt-form-label" }, [
                _vm._v("Delivery Type"),
              ]),
              _vm._v(" "),
              _c(
                "b-form-select",
                {
                  scopedSlots: _vm._u([
                    {
                      key: "first",
                      fn: function () {
                        return [
                          _c(
                            "b-form-select-option",
                            { attrs: { value: null, disabled: "" } },
                            [_vm._v("Select Type")]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                  model: {
                    value: _vm.deliveryType,
                    callback: function ($$v) {
                      _vm.deliveryType = $$v
                    },
                    expression: "deliveryType",
                  },
                },
                [
                  _vm._v(" "),
                  _c("b-form-select-option", { attrs: { value: "INPX" } }, [
                    _vm._v("INPX"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "trt-field trt-field--date" },
            [
              _c("label", { staticClass: "trt-form-label text-nowrap" }, [
                _vm._v("Requested Delivery Date"),
              ]),
              _vm._v(" "),
              _c("b-form-input", {
                attrs: {
                  type: "date",
                  placeholder: "Select date",
                  format: "yyyy/mm/dd",
                },
                model: {
                  value: _vm.deliveryDate,
                  callback: function ($$v) {
                    _vm.deliveryDate = $$v
                  },
                  expression: "deliveryDate",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "trt-field trt-field--notes" },
            [
              _c("label", { staticClass: "trt-form-label" }, [_vm._v("Notes")]),
              _vm._v(" "),
              _c("b-form-textarea", {
                attrs: { rows: "1", "max-rows": "3" },
                model: {
                  value: _vm.note,
                  callback: function ($$v) {
                    _vm.note = $$v
                  },
                  expression: "note",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.statsObjs.length
        ? _c(
            "div",
            { staticClass: "stats-data px-3 pt-3" },
            [
              _c("div", { staticClass: "stats-header-row" }, [
                _c("span", { staticClass: "trt-section-title" }, [
                  _vm._v("Statistical Analysis"),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "d-flex align-items-center" },
                  [
                    _c("transition", { attrs: { name: "fade" } }, [
                      _vm.isCellsLoading
                        ? _c(
                            "span",
                            {
                              staticClass:
                                "stats-loading-banner d-flex align-items-center mr-3",
                            },
                            [
                              _c("span", {
                                staticClass:
                                  "spinner-border spinner-border-sm loading-banner-spinner mr-2",
                                attrs: { role: "status" },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "loading-banner-text" },
                                [_vm._v("Statistics are loading…")]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _vm.showRequestBtn && _vm.statsObjs.length === 1
                      ? _c(
                          "b-button",
                          {
                            staticClass: "request-btn",
                            attrs: {
                              disabled: _vm.dataLoading,
                              variant: "none",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.openConfirmation(_vm.statsObjs[0], 0)
                              },
                            },
                          },
                          [
                            _c("fa", {
                              staticClass: "mr-1",
                              attrs: { icon: ["fas", "paper-plane"] },
                            }),
                            _vm._v(" Request\n                "),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _vm._l(_vm.statsObjs, function (statsObj, index) {
                return _c("div", { key: index, staticClass: "sample-block" }, [
                  _vm.statsObjs.length > 1
                    ? _c(
                        "div",
                        { staticClass: "sample-block-header" },
                        [
                          _c("span", { staticClass: "sample-block-title" }, [
                            _vm._v("Sample " + _vm._s(index + 1)),
                          ]),
                          _vm._v(" "),
                          _vm.showRequestBtn
                            ? _c(
                                "b-button",
                                {
                                  staticClass: "request-btn",
                                  attrs: {
                                    disabled: _vm.dataLoading,
                                    variant: "none",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openConfirmation(
                                        statsObj,
                                        index
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("fa", {
                                    staticClass: "mr-1",
                                    attrs: { icon: ["fas", "paper-plane"] },
                                  }),
                                  _vm._v(
                                    " Request " +
                                      _vm._s(index + 1) +
                                      "\n                "
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "stat-card stat-card-summary" }, [
                    _c(
                      "div",
                      { staticClass: "stat-card-header stat-card-header-dark" },
                      [
                        _c("fa", {
                          staticClass: "mr-2",
                          attrs: { icon: ["fas", _vm.summarySection.icon] },
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.summarySection.title))]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "stat-card-summary-body" },
                      _vm._l(_vm.summarySection.rows, function (row) {
                        return _c(
                          "div",
                          { key: row.key, staticClass: "summary-metric" },
                          [
                            _c(
                              "span",
                              { staticClass: "summary-metric-label" },
                              [_vm._v(_vm._s(row.label))]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "summary-metric-value" },
                              [
                                statsObj[row.key] !== undefined
                                  ? [_vm._v(_vm._s(statsObj[row.key]))]
                                  : _vm.dataLoading
                                  ? _c("span", {
                                      staticClass:
                                        "spinner-border spinner-border-sm cell-spinner",
                                      attrs: { role: "status" },
                                    })
                                  : [_vm._v(_vm._s(row.fallback))],
                              ],
                              2
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.hasPolygons
                    ? _c(
                        "div",
                        { staticClass: "stat-columns" },
                        _vm._l(_vm.detailColumns, function (column, colIdx) {
                          return _c(
                            "div",
                            { key: colIdx, staticClass: "stat-column" },
                            _vm._l(column, function (section) {
                              return _c(
                                "div",
                                {
                                  key: section.title,
                                  staticClass: "stat-card",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "stat-card-header" },
                                    [
                                      _c("fa", {
                                        staticClass: "mr-2",
                                        attrs: { icon: ["fas", section.icon] },
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(_vm._s(section.title)),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "stat-card-body" },
                                    _vm._l(section.rows, function (row) {
                                      return _c(
                                        "div",
                                        {
                                          key: row.key,
                                          staticClass: "stat-line",
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "stat-line-label" },
                                            [_vm._v(_vm._s(row.label))]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "stat-line-value" },
                                            [
                                              statsObj[row.key] !== undefined
                                                ? [
                                                    _vm._v(
                                                      _vm._s(statsObj[row.key])
                                                    ),
                                                  ]
                                                : _vm.dataLoading
                                                ? _c("span", {
                                                    staticClass:
                                                      "spinner-border spinner-border-sm cell-spinner",
                                                    attrs: { role: "status" },
                                                  })
                                                : [
                                                    _vm._v(
                                                      _vm._s(row.fallback)
                                                    ),
                                                  ],
                                            ],
                                            2
                                          ),
                                        ]
                                      )
                                    }),
                                    0
                                  ),
                                ]
                              )
                            }),
                            0
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                ])
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "confirmLidarRequest",
            size: "md",
            "content-class": "sub-menu-transparent",
            title: "Data Request Confirmation",
          },
          scopedSlots: _vm._u([
            {
              key: "modal-header",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-between w-100",
                    },
                    [
                      _c(
                        "h5",
                        { staticClass: "mb-0 font-weight-semibold text-white" },
                        [_vm._v("LiDAR Data Request Confirmation")]
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "modal-footer",
              fn: function () {
                return [
                  _c(
                    "b-row",
                    { staticClass: "w-100 justify-content-end" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "close-btn px-4 py-2",
                          on: {
                            click: function ($event) {
                              return _vm.closeLidarConfirmation()
                            },
                          },
                        },
                        [_vm._v("Close")]
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _vm._v(" "),
          _c(
            "b-container",
            [
              _c(
                "b-row",
                { staticClass: "py-2 text-center" },
                [
                  _c("b-col", [
                    _vm._v(
                      "\n                    LiDAR Data request with total segments length of "
                    ),
                    _c("b", { staticClass: "highlight" }, [
                      _vm._v(
                        _vm._s(_vm.requestedSample["All segments length"])
                      ),
                    ]),
                    _vm._v(" will be sent to DMP.\n                "),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "py-2 text-center" },
                [
                  _c("b-col", [
                    _vm._v(
                      "Please confirm and click submit to send the request."
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                {
                  staticClass: "py-2 w-100 justify-content-center",
                  attrs: { "no-gutters": "" },
                },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "confirm-btn px-3 py-2",
                      on: {
                        click: function ($event) {
                          return _vm.sendLidarRequest()
                        },
                      },
                    },
                    [_vm._v("Submit")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }